
import Form from "./Form.vue";
import UNData from "./UNData";
import { mapGetters } from "vuex";

export default {
  name: "app-un-create",
  data() {
    return {
      un: new UNData({}),
    };
  },
  components: {
    Form,
  },
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
